var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero__img",attrs:{"id":"banner"}},[_c('img',{attrs:{"src":_vm.FixedHero,"fetchpriority":"high","alt":_vm.altHero}})])
}
var staticRenderFns = []

export { render, staticRenderFns }